const reducer = (params, param) => {
  const [key, value] = param.split('=');
  params[key.toLowerCase()] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
  return params;
};

export default (query = window.location.search) => {
  const index = query.search(/[?#]/);

  return (~index ? query.slice(index + 1) : query)
    .split('&')
    .reduce(reducer, {});
};
